import { jsx } from "react/jsx-runtime";
import { cn } from "../../utils/index.js";
import { Span } from "../Text/Span.js";
import { reviewBadgeVariants } from "./ReviewBadge.variants.js";
function ReviewBadge({ rating, className, onClick, ...props }) {
    const { badgeSlot, textSlot } = reviewBadgeVariants(props);
    return /*#__PURE__*/ jsx("div", {
        className: cn(badgeSlot(), className),
        onClick: onClick,
        ...props,
        children: /*#__PURE__*/ jsx(Span, {
            className: textSlot(),
            bold: true,
            align: "center",
            children: rating
        })
    });
}
export { ReviewBadge };
